import { Injectable, Injector } from '@angular/core';
import { CanActivate } from '@angular/router';

import { OfferContentConfiguration } from '@frontend/promo-homewidget';
import { PromoDesignSystemConfiguration } from '@frontend/promo-utils';
import {
    AuthService,
    ClientConfigProductName,
    ClientConfigService,
    CookieService,
    MenuItemsService,
    MenuSection,
    NavigationService,
    ProductService,
} from '@frontend/vanilla/core';

import { CommonClientConfiguration } from './client-configs/promo-common-config';
import { PromoClientConfiguration } from './client-configs/promo-config';
import { PromoFormattersConfiguration } from './client-configs/promo-formatters-config';
import { LogoutHandlerService } from './common/logout-handler.service';

@Injectable({ providedIn: 'root' })
export class PromoActivateGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private navigationService: NavigationService,
        private logoutHandler: LogoutHandlerService,
        private menuService: MenuItemsService,
        private offerContentConfiguration: OfferContentConfiguration,
        private cookieService: CookieService,
        private promoFormattersConfig: PromoFormattersConfiguration,
        private clientConfigService: ClientConfigService,
        private commonClientConfig: CommonClientConfiguration,
        private promoConfig: PromoClientConfiguration,
        private designSystemConfig: PromoDesignSystemConfiguration,
        private injector: Injector,
        private productService: ProductService,
    ) {}

    async canActivate() {
        const configs = [] as any;
        if (!this.promoFormattersConfig?.isConfigReady) configs.push(PromoFormattersConfiguration);
        if (!this.offerContentConfiguration?.isConfigReady) configs.push(OfferContentConfiguration);
        if (!this.commonClientConfig?.isConfigReady) configs.push(CommonClientConfiguration);
        if (!this.promoConfig?.isConfigReady) configs.push(PromoClientConfiguration);
        if (!this.designSystemConfig?.isConfigReady) configs.push(PromoDesignSystemConfiguration);

        if (configs.length > 0) await this.clientConfigService.load('', configs);

        if (this.promoFormattersConfig?.localTimeZones) {
            const timeZone = new Date()?.toTimeString()?.split('(')[1]?.replace(')', '')?.toLowerCase();
            const deviceTimeZone = this.promoFormattersConfig?.localTimeZones[timeZone];
            this.cookieService.put('deviceTimeZoneId', deviceTimeZone);
        }

        this.navigationService.locationChange.subscribe(() => {
            const redirectUrl = this.logoutHandler.handleLogout();
            this.authService.changeRedirectUrlAfterLogout(redirectUrl);
        });

        if (this.offerContentConfiguration?.isEpcotEnabled) {
            this.menuService.setActive(MenuSection.BottomNav, 'promotions_epcot');
        }

        this.registerPromoInProductService();

        return true;
    }

    registerPromoInProductService() {
        this.injector.get(ProductService).register(ClientConfigProductName.PROMO, this.injector);
        this.productService.setActive(ClientConfigProductName.PROMO);
    }
}
